<template>
  <div class="business-data">
    <div class="breadcrumb">
      <i class="el-icon-arrow-left"></i>
      <el-breadcrumb separator-class="el-icon-arrow-left">
        <el-breadcrumb-item>数据统计</el-breadcrumb-item>
        <el-breadcrumb-item>财务数据统计</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="line"></div>
    <div class="content">
      <div class="bar">
        <span class="title">财务信息</span>
      </div>
      <el-divider class="divider"></el-divider>
      <div class="business-num">
        <div class="trnt">
          <div class="business-trend">
            <p class="title2">存证业务量趋势</p>
            <div class="box">
              <div class="save-total">
                <div class="icon yellow-bg icon-wrap">
                  <i class="icon icon-qitatubiao-1 yellow-bg"></i>
                </div>
                <div class="save-total-text">
                  <p class="explain">累计充值金额</p>
                  <p class="num" :title="rechargeMoneyOrigin">{{ rechargeMoney }}元</p>
                </div>
              </div>
              <div class="save-total mr0">
                <div class="icon icon-wrap">
                  <i class="icon icon-taocan-2"></i>
                </div>
                <div class="save-total-text">
                  <!-- <p class="explain">累计已消费金额（万元）</p> -->
                  <p class="explain">累计已消费金额</p>
                  <p class="num" :title="consumeMoneyOrigin">{{ consumeMoney }}元</p>
                </div>
              </div>
            </div>
          </div>
          <div class="business-column">
            <div class="column-top">
              <p class="title2">
                {{
                  timeBusinessNumActive == '1'
                    ? '昨日'
                    : timeBusinessNumActive == '2'
                    ? '本周'
                    : '本月'
                }}收入:{{ statisticsTotal }}元
              </p>
              <div class="time-right">
                <template v-for="(item, index) in listTypeOptions">
                  <span
                    :key="item.lebel"
                    @click="
                      changeTimeBusinessTrendsActive(
                        item.value,
                        'timeBusinessNumActive'
                      )
                    "
                    :class="[
                      item.value == timeBusinessNumActive ? 'active' : '',
                    ]"
                    class="item"
                    >{{ item.lebel }}</span
                  >
                  <el-divider
                    v-if="index != listTypeOptions.length - 1"
                    :key="item.lebel"
                    direction="vertical"
                  ></el-divider>
                </template>
              </div>
            </div>

            <div id="column-chart" ref="Chart01"></div>
          </div>
        </div>

        <div class="business-ranking">
          <p class="title2">客户消费排名</p>
          <table
            style="width:100%"
            class="rank-table"
            cellpadding="0"
            border="0"
          >
            <tr
              v-for="(item, index) in rankData"
              class="mtr"
              :key="index"
              :class="index % 2 == 0 ? 'active' : ''"
            >
              <td class="item1 tc">{{ index + 1 }}</td>
              <td class="item2">{{ item.epName }}</td>
              <td class="item3">{{ item.statisticNum }}元</td>
            </tr>
          </table>

          <!-- <div v-if="total > 0">
            <Pagination
              :layout="layout"
              :total="total"
              prevtext="上一页"
              nexttext="下一页"
              :pageSize="pageSize"
              @handleCurrentChange="handleCurrentChange"
              :currentPage="currentPage"
            ></Pagination>
          </div> -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Api from '@/api'
import moment from 'moment'
import { statusCode } from '@/config'
// import Pagination from '@/components/common/Pagination.vue'

export default {
  name: 'BusinessData',
  components: {
    // Pagination,
  },
  data() {
    return {
      rechargeMoney: 0, // 累计充值金额
      rechargeMoneyOrigin: 0,
      consumeMoney: 0, // 累计已消费金额
      consumeMoneyOrigin: 0,
      layout: 'prev, next',
      total: 1, // 总页数
      pageSize: 15, // 每页显示条数
      currentPage: 1, // 当前页
      brokenStatisticTime: [], // 统计单个节点时间(柱状) broken
      brokenStatisticNum: [], // 统计出来的数量量(柱状)
      thisweekTotal: '20', // 本周收入所有
      statisticsTotal: 0, // 统计的总数
      listType: 1, // 时间段 1近24⼩小时，2近7天，3近30天
      listTypeOptions: [
        {
          value: '1',
          lebel: '昨日',
        },
        {
          value: '2',
          lebel: '近7天',
        },
        {
          value: '3',
          lebel: '近30天',
        },
      ],
      timeBusinessNumActive: 3,
      dateStatus: 'week',
      rankData: [
      ],
    }
  },
  beforeDestroy() {
    if (!this.chart01) {
      return
    }
    // window.removeEventListener('resize')
    this.chart01.dispose()
    this.chart01 = null
  },
  mounted() {
    const self = this
    const echarts = require('echarts')
    this.myChart = echarts.init(document.getElementById('column-chart'))

    this.initAll()

    // 累计充值金额
    this.getFinancialStatisticTotal()

    // 累计消费⾦金金额
    this.getFinancialConsumptionTotal()

    // 获取本周收⼊金额
    // this.getFinancialThisWeekTotal()

    // 一段时间统计数据
    this.getFinancialStatisticListTime(3).then((res) => {
      this.initColumnChart()
    })

    // 业务量量排名
    this.getFinancialStatisticRankList()
  },
  methods: {
    handleCurrentChange(val) {
      this.currentPage = val
      this.getFinancialStatisticRankList()
    },
    getFinancialStatisticRankList() {
      const params = {
        count: this.pageSize,
        start: this.currentPage,
      }
      Api.statistics.getFinancialStatisticRankList(params).then((res) => {
        if (res.retCode === statusCode.SUCCESS) {
          this.rankData = res.Detail
          this.total = res.total
        } else {
          this.$message({
            showClose: true,
            message: res.retMsg,
            type: 'error',
          })
        }
      })
    },

    getFinancialStatisticListTime(dd) {
      //   dd 1近24⼩小时，2近7天，3近30天
      return Api.statistics.getFinancialStatisticListTime(dd).then((res) => {
        if (res.retCode === statusCode.SUCCESS) {
          this.brokenStatisticTime = []
          this.brokenStatisticNum = []
          if (res.Detail) {
            this.statisticsTotal = 0
            res.Detail.forEach((item) => {
              this.statisticsTotal += item.statisticNum
              this.brokenStatisticTime.push(this.addZero(item.statisticTime))
              this.brokenStatisticNum.push(item.statisticNum)
            })
          }
        } else {
          this.$message({
            showClose: true,
            message: res.retMsg,
            type: 'error',
          })
        }
      })
    },
    addZero(str) {
      if (str.length > 2) {
        return str
      } else if (str.length == 2) {
        return `${str}:00`
      }
    },
    // getFinancialThisWeekTotal() {
    //   Api.statistics.getFinancialThisWeekTotal().then((res) => {
    //     if (res.retCode === statusCode.SUCCESS) {
    //       console.log('res', res)
    //       this.thisweekTotal = res.total
    //     } else {
    //       this.$message({
    //         showClose: true,
    //         message: res.retMsg,
    //         type: 'error',
    //       })
    //     }
    //   })
    // },
    getFinancialConsumptionTotal() {
      Api.statistics.getFinancialConsumptionTotal().then((res) => {
        if (res.retCode === statusCode.SUCCESS) {
          console.log('res', res)
          this.consumeMoneyOrigin = res.total
          console.log('+++++++++++++++++++++++', res.total)

          this.consumeMoney = this.numberFormat(res.total).value + this.numberFormat(res.total).unit
        } else {
          this.$message({
            showClose: true,
            message: res.retMsg,
            type: 'error',
          })
        }
      })
    },
    numberFormat(value) {
      let param = {}
      let k = 10000
      // 万：代表的是10的四次方.
      // 亿：代表的是10的八次方.
      // 兆：代表的是10的十二次方.
      // 京：代表的是10的十六次方.

      // 垓：代表的是10的二十次方.
      // 杼：代表的是10的二十四次方.
      // 穰：代表的是10的二十八次方.
      // 沟：代表的是10的三十二次方.

      // 涧：代表的是10的三十六次方.
      // 正：代表的是10的四十次方.
      // 载：代表的是10的四十四次方.
      // 极：代表的是10的四十八次方.

      // 恒河沙：代表的是10的五十二次方.
      // 阿僧□：代表的是10的五十六次方.
      // 那由它：代表的是10的六十次方.
      // 不可思议：代表的是10的六十四次方.
      // 无量：代表的是10的六十八次方.
      // 大数：代表的是10的七十二次方.
      let sizes = ['', '万', '亿', '万亿','万万亿','垓','杼','穰','沟','涧','正','载','极','恒河沙','阿僧□','那由它','不可思议','无量','大数']
      let i = 0
      if (value < k) {
        param.value = value
        param.unit = ''
      } else {
        i = Math.floor(Math.log(value) / Math.log(k))
        param.value = (value / Math.pow(k, i)).toFixed(2)
        param.unit = sizes[i]
      }
      return param
    },
    getFinancialStatisticTotal() {
      Api.statistics.getFinancialStatisticTotal().then((res) => {
        if (res.retCode === statusCode.SUCCESS) {
          this.rechargeMoneyOrigin = res.total
          this.rechargeMoney = this.numberFormat(res.total).value + this.numberFormat(res.total).unit
        } else {
          this.$message({
            showClose: true,
            message: res.retMsg,
            type: 'error',
          })
        }
      })
    },
    changeTimeBusinessTrendsActive(val, str) {
      this[str] = val
      this.getFinancialStatisticListTime(val).then((res) => {
        if (str == 'timeBusinessNumActive') {
          this.initColumnChart()
        }
      })
    },
    initAll() {
      const self = this
      window.onresize = function() {
        self.chart01 = self.$echarts.init(self.$refs.Chart01)
        if (self.$refs && self.$refs.Chart01) {
          if (self.brokenStatisticTime.length > 0) {
            // 有数据的时候
            self.chart01.resize()
          }
        }
      }
    },
    initColumnChart() {
      const option = {
        title: {
          show: this.brokenStatisticTime.length === 0,
          extStyle: {
            color: 'grey',
            fontSize: 20,
          },
          text: '暂无数据',
          left: 'center',
          top: 'center',
        },
        tooltip: {
          trigger: 'axis',
          formatter(params) {
            return `${params[0].name}<br>金额:${params[0].data}元`
          },
        },
        grid: {
          top: '10px',
          left: '1%',
          right: '1%',
          bottom: '5%',
          containLabel: true,
        },
        xAxis: {
          type: 'category',
          data: this.brokenStatisticTime,
        },
        yAxis: {
          type: 'value',
        },
        series: [
          {
            data: this.brokenStatisticNum,
            type: 'bar',
            itemStyle: {
              color: '#91B5FF',
            },
            barWidth: '16px',
          },
        ],
      }
      this.myChart.setOption(option)
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-divider--horizontal {
  margin-top: 13px;
}
.business-data {
  width: 100%;
  min-height: calc(100vh - 110px);
  background-color: #ffffff;
  .line {
    width: 100%;
    height: 10px;
    background-color: #f7f7f7;
  }
  .breadcrumb {
    display: flex;
    height: 50px;
    background-color: #ffffff;
    line-height: 50px;
    padding-left: 15px;
    i {
      line-height: 50px;
      margin-left: 15px;
    }
    .el-breadcrumb {
      line-height: 50px;
    }
  }
  .content {
    background-color: #ffffff;
    padding: 30px;
    .bar {
      width: 100%;
      font-size: 20px;
      position: relative;
      display: flex;
      justify-content: space-between;
      .title {
        margin-left: 28px;
      }
      .title::before {
        position: absolute;
        content: '';
        left: 12px;
        top: 6px;
        width: 4px;
        height: 16px;
        background-color: #2455ce;
      }
    }
    .business-num {
      display: flex;
      .trnt {
        width: 60%;
      }
      .tip {
        color: #333333;
        line-height: 60px;
        // margin-left: 60px;
        position: relative;
        font-size: 16px;
      }
      .business-trend {
        .tip {
          font-size: 16px;
          font-family: PingFang SC;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
        }
        .box {
          display: flex;
          .save-total {
            width: 50%;
            height: 102px;
            background: linear-gradient(
              0deg,
              rgba(253, 254, 255, 1),
              rgba(235, 242, 255, 1)
            );
            border: 1px solid rgba(214, 233, 255, 1);
            border-radius: 8px;
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            margin-right: 20px;
            display: flex;
            align-items: center;
            .save-total-text {
              margin-left: 15px;
              flex: 1
            }
            .icon {
              width: 61px;
              height: 61px;
              overflow: hidden;
              border-radius: 50%;
              background-color: #90aaeb;
              /* margin-top: 10px; */
              text-align: center;
              line-height: 61px;
              color: #ffffff;
              font-size: 40px;
            }
            .icon-wrap{
              margin-left: 20px
            }
            .yellow-bg {
              background-color: #dec285 !important;
            }
            .explain {
              color: #999999;
              font-size: 14px;
              width: 100%;
              height: 20px;
              text-align: left;
            }
            .num {
             // width: 82px;
              font-size: 26px;
              font-family: PingFangSC;
              font-weight: bold;
              color: rgba(3, 3, 3, 1);
            }
            .info {
              color: #999999;
            }
          }
          .mr0 {
            margin-right: 0px !important;
          }
        }
      }
      .business-ranking {
        flex-grow: 1;
        width: 40%;
        margin-left: 60px;
        .rank-table {
          border-collapse: collapse;
          tr {
            height: 30px;
            line-height: 30px;
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 500;
            color: rgba(51, 51, 51, 1);
            border-left: none;
            border-right: none;
          }
          .mtr {
            display: flex;
            width: 100%;
          }
          .tc {
            text-align: center;
          }
          .item1 {
            flex: 0 0 50px;
          }
          .item2 {
            width: 100px;
            flex: 1;
            overflow: hidden;
            text-overflow: ellipsis;
            white-space: nowrap;
          }
          .item3 {
            flex: 0 0 100px;
            text-align: right;
            padding-right: 15px;
          }
          .active {
            background: rgba(52, 128, 239, 0.1);
          }
        }
      }
    }
    .business-column {
      width: 100%;
      .column-top {
        display: flex;
        margin-top: 36px;
        justify-content: space-between;
      }
      #column-chart {
        width: 100%;
        height: 250px;
      }
    }
  }
}
.title2 {
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: rgba(51, 51, 51, 1);
  margin-bottom: 25px;
}
.time-right {
  text-align: right;
  .item {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 500;
    color: rgba(102, 102, 102, 1);
    cursor: pointer;
  }
  .active {
    color: #2455ce;
  }
}
.mt40 {
  margin-top: 40px;
}
</style>
